window.PaymentAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);


    self.getSubscriptionPackages = function (packageId) {
        var defer = $q.defer();
        var params = {};

        if (packageId) {
            params['packageId'] = packageId;
        }

        _protected.request('payment/get_subscription_packages', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getPackageDetails = function (packageId) {
        var defer = $q.defer();
        _protected.request('payment/get_packages/' + packageId, 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getSubscriptionPackageDetails = function (packageId) {
        var defer = $q.defer();
        _protected.request('payment/get_subscription_packages/' + packageId, 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getPackages = function (mode) {
        var defer = $q.defer();
        _protected.request('payment/get_packages', 'GET',{
            mode: mode,
        })
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.buyPackage = function (data) {
        var defer = $q.defer();
        var payload = {
            "credit_card": data['token'],
            "brand_id": data['brandId'],
            "package_id": data['packageId'],
            "save_payment_method": data['savePaymentMethod'],
        };

        if(data['coupon']){
            payload['coupon'] = data['coupon'];
        }

        _protected.request('stripe/buy_package', 'PUT', payload).then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.buySubscriptionPackage = function (cardDetails, brandId, packageId, couponCode, packageCode) {
        var deferred = $q.defer();
        var checkoutData = {
            "credit_card": cardDetails.id,
            "credit_card_id": cardDetails.existing_id,
            "brand_id": parseInt(brandId),
            "package_id": parseInt(packageId),
            "coupon_code": couponCode,
            "subscription_package_code": packageCode,
            "save_payment_method": true
        };
        StripeAPI.subscribeToPackage(brandId, checkoutData).then(function (resp) {
            deferred.resolve(resp)
        }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    self.redeemCoupon = function (couponCode, packageId, subscriptionPackageId) {
        var defer = $q.defer(),
            requestData = {'coupon_code': couponCode, 'package_id': packageId};

        if (subscriptionPackageId) {
            requestData.subscription_package_id = subscriptionPackageId;
        }

        _protected.request('coupons/redeem_coupon', 'POST', requestData).then(function (res) {
            if (res && res.data && res.status === 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.redeemLMSCoupon = function (couponCode) {
        var defer = $q.defer();

        var params = {
            mode: "LMS"
        };

        _protected.request('coupons/' + couponCode, 'GET', params).then(function (res) {
            if (res && res.data && res.status === 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getBrandSavedCards = function (brandId) {
        var defer = $q.defer();
        _protected.request('stripe/payment_method/' + brandId, 'GET').then(function (res) {
            if (res && res.data && res.status === 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }

        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };
};
